import React, { memo } from 'react'
import styles from './AddOnForm.module.scss'
import BuildingTypeForm from '../building-type-form/BuildingTypeForm';
import { AddOnOption } from '../StoreFrontItem';
import { SolarProductObject } from '../../../../model/solar-product/solar-product-with-recommendations';
import { BuildingType } from '../../../../model/building-type';
import { RoofType } from '../../../../model/solar-recommendation-form/roofType';

type Props = {
    solarProduct?: SolarProductObject;
    selectedAddOns: AddOnOption[];
    setSelectedAddOn: (addOns: AddOnOption[]) => void;
    selectedRoofType?: RoofType;
    setSelectedRoofType: (roofType: RoofType) => void;
    floorsNumber: number;
    setFloorsNumber: (floors: number) => void
}

const AddOnForm: React.FC<Props> = memo((props: Props) => {
    const { solarProduct, selectedAddOns, setSelectedAddOn, selectedRoofType, setSelectedRoofType, floorsNumber, setFloorsNumber } = props;

    const isInstallationSelected = selectedAddOns.findIndex(x => x === AddOnOption.Installation) !== -1;
    const isInsuranceSelected = selectedAddOns.findIndex(x => x === AddOnOption.Insurance) !== -1;
    const isRoofTypeSelected = selectedRoofType !== null && selectedRoofType !== undefined;
    const isBungalowSelected = selectedRoofType?.premiseType === "Bungalow";

    const setAddOn = (addOn: AddOnOption) => {
        if (selectedAddOns.includes(addOn)) {
            setSelectedAddOn(selectedAddOns.filter(x => x !== addOn));
        } else {
            setSelectedAddOn([...selectedAddOns, addOn]);
        }
    }

    function handleMouseDown(event: React.MouseEvent): void {
        event.stopPropagation();
	}

    return (
        <div className={styles.addOn}>
            Add-on
            <div className={`${styles.addOnSelect} ${isInstallationSelected ? styles.selected : ''}`} onClick={() => setAddOn(AddOnOption.Installation)}>
                <div className={styles.addOnSelectHeader}>
                    <label className={styles.selection}>
                        <input type='checkbox' className={styles.checkbox} checked={isInstallationSelected} readOnly />
                        <div className={styles.checkmark}></div>
                        Installation
                    </label>
                    {isRoofTypeSelected && (
                        <span>
                            ₦{isBungalowSelected ? solarProduct?.solarProduct.installationCostForBungalow : (solarProduct?.solarProduct.installationCostForFloorForStoryBuilding ?? 0) * floorsNumber}
                        </span>
                    )}
                </div>
                {isInstallationSelected && (
                    <div onClick={handleMouseDown}>
                        <BuildingTypeForm selectedRoofType={selectedRoofType} setSelectedRoofType={setSelectedRoofType} floorsNumber={floorsNumber} setFloorsNumber={setFloorsNumber} />
                    </div>
                )}
            </div>
            <div className={`${styles.addOnSelect} ${isInsuranceSelected ? styles.selected : ''}`} onClick={() => setAddOn(AddOnOption.Insurance)}>
                <div className={styles.addOnSelectHeader} >
                    <label className={styles.selection}>
                        <input type='checkbox' className={styles.checkbox} checked={isInsuranceSelected} readOnly />
                        <div className={styles.checkmark}></div>
                        Insurance
                    </label>
                    {/* ₦43,000 */}
                </div>
            </div>
        </div>
    )
})

export default AddOnForm
